// extracted by mini-css-extract-plugin
export default {"pla":"App_pla__1bUVN"};